import BaseUtils from './base'

class StoreUtils extends BaseUtils {
  store() {
    return this.vue().$store
  }

  getter(key) {
    if (this.store()) {
      const value = this.store().getters[key]
      return value
    }
  }

  commit(key, value) {
    this.store().commit(key, value)
  }

  dispatch(key, value) {
    return this.store().dispatch(key, value)
  }

  watch(key, value) {
    this.store().watch(key, value)
  }
}

export default StoreUtils

const instance = new StoreUtils()
export function dispatch(key, value) {
  instance.dispatch(key, value)
}

export function getter(key) {
  return instance.getter(key)
}

export function commit(key, value) {
  return instance.commit(key, value)
}

export function watch(key, value) {
  instance.watch(key, value)
}
